export default (): __esri.MapView | undefined => {
    return window.klok?.view || undefined
}
